import { render, staticRenderFns } from "./NovelCover.vue?vue&type=template&id=926edc10&scoped=true"
import script from "./NovelCover.vue?vue&type=script&lang=ts"
export * from "./NovelCover.vue?vue&type=script&lang=ts"
import style0 from "./NovelCover.vue?vue&type=style&index=0&id=926edc10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926edc10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('926edc10')) {
      api.createRecord('926edc10', component.options)
    } else {
      api.reload('926edc10', component.options)
    }
    module.hot.accept("./NovelCover.vue?vue&type=template&id=926edc10&scoped=true", function () {
      api.rerender('926edc10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/NovelCover.vue"
export default component.exports